import {faFileInvoice, faHistory, faHome, faSignOutAlt} from "@fortawesome/free-solid-svg-icons";

export const CHANGE_STATUS = "sideMenu/changeStatus";

export type Anchor = 'top' | 'left' | 'bottom' | 'right';

export enum SlideOptions {
  INICIO = "Inicio",
  FACTURAS = "Facturas",
  INFORME = "Informe gerencial",
  SALIR = "Salir",
  HISTORIAL = "Historial"
}

const {SALIR, FACTURAS,INFORME,INICIO,HISTORIAL} = SlideOptions;

export const OPTION_LIST = [
  {
    text: INICIO,
    icon: faHome
  },
  {
    text: HISTORIAL,
    icon: faHistory
  },
  {
    text: FACTURAS,
    icon: faFileInvoice
  },
  {
    text: INFORME,
    icon: faFileInvoice
  },
  {
    text: SALIR,
    icon: faSignOutAlt
  }
];
